import GlobalUpload from "./src/main.vue";

GlobalUpload.install = (Vue) => {
    Vue.component(GlobalUpload.name, GlobalUpload)
}

export default GlobalUpload;